import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QuestionsComponent } from './questions/questions.component';
import { QuizzComponent } from './quizz/quizz.component';
import { VotesComponent } from './votes/votes.component';
import { TagCloudComponent } from './tagcloud/tagcloud.component';

const routes: Routes = [
  { path: `questions`, component: QuestionsComponent },
  { path: `quizz`, component: QuizzComponent },
  { path: `votes`, component: VotesComponent },
  { path: `tagcloud`, component: TagCloudComponent },
  { path: '**',  redirectTo: `questions`,  pathMatch: 'full'}
];

export const Router: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/app.routes.ts